export const MAILING_CHATS_CAP = 1000

/** Toggle one chat; no-op when at cap and not already selected (1001st check
 *  blocked). Unchecking always works regardless of the cap (D-15). */
export const toggleChat = (
  selected: number[],
  chatId: number,
  cap: number = MAILING_CHATS_CAP,
): number[] => {
  if (selected.includes(chatId)) {
    return selected.filter((id) => id !== chatId)
  }
  return selected.length >= cap ? selected : [...selected, chatId]
}

/** True at/over the cap — drives the checkbox `disabled` state and the
 *  counter's error color. */
export const isAtCap = (
  selected: number[],
  cap: number = MAILING_CHATS_CAP,
): boolean => selected.length >= cap

/** Дельта страницы для контролируемого DataGrid: из текущего выбора убираются
 *  id страницы, НЕ отмеченные в модели, и добавляются отмеченные. Идущие вне
 *  страницы id не трогаются (накопление между страницами). Свежий добор
 *  клампится к капу (уже выбранные сохраняют свои слоты). */
export const applyPageSelection = (
  current: number[],
  pageIds: number[],
  selectedIds: number[],
  cap: number = MAILING_CHATS_CAP,
): number[] => {
  const selectedSet = new Set(selectedIds)
  const pageSet = new Set(pageIds)
  const kept = current.filter((id) => !pageSet.has(id) || selectedSet.has(id))
  const fresh: number[] = []
  const freeSlots = Math.max(0, cap - kept.length)
  for (const id of pageIds) {
    if (!selectedSet.has(id) || kept.includes(id)) continue
    if (fresh.length >= freeSlots) break
    fresh.push(id)
  }
  return [...kept, ...fresh]
}
